AgrimarketControllers.controller('disableSubscriptionController', ['$scope', '$rootScope', 'configurationFactory','$filter',
    function ($scope, $rootScope, configurationFactory, $filter) {

}]);